import { render, staticRenderFns } from "./ShareInformation.vue?vue&type=template&id=15f5bc5f"
import script from "./ShareInformation.vue?vue&type=script&lang=js"
export * from "./ShareInformation.vue?vue&type=script&lang=js"
import style0 from "./ShareInformation.vue?vue&type=style&index=0&id=15f5bc5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports